export default [
  {
    name: 'Registration',
    duration: 40,
  },
  // Hall 1
  [
    {
      name: 'Opening',
      duration: 20,
    },
        {
      name: 'npm Security: Key Threats & Real Cases',
      speakerId: 'anastasia',
      duration: 35,
      levels: [],
      lang: 'ru',
      videoUrl: 'https://youtu.be/MAc4vU2V6v0?si=e3dkyjsNd-7V0iR8'
    },
    {
      name: 'Form forms and reform that way',
      speakerId: 'pavel',
      duration: 35,
      levels: [],
      lang: 'ru',
      videoUrl: 'https://youtu.be/ks1UdpyF3E0?si=WBwozyv8JxXMMEXC'
    },
    {
      name: 'From First Experiments to AI Agents: Adoption Experience and Future Challenges',
      speakerId: 'david',
      duration: 30,
      levels: [],
      lang: 'ru',
      videoUrl: 'https://youtu.be/PUGEgu6o5cw?si=WWvLWNjka5gMNZxO'
    },
    {
      name: 'Break',
      duration: 15,
    },
    {
      name: 'Do not be afraid. Building AI powered apps with NodeJS and Gemini',
      speakerId: 'armen',
      duration: 35,
      levels: [1,2],
      lang: 'am',
      videoUrl: 'https://youtu.be/neaG0t2BfmE?si=yFjtmbibscFQqmHC'
    },
    {
      name: 'DynamoDB, Neptune, and OpenSearch: A Unified Approach to Collaborative Editing and Search',
      speakerId: 'melik',
      duration: 30,
      levels: [1, 2],
      lang: 'am',
      videoUrl: 'https://youtu.be/aOsH3OOwNq4?si=sPGIyOWuoG2TvSw9'
    },
    {
      name: 'Break',
      duration: 50,
    },
    {
      name: 'High performance computing: the modern approach',
      speakerId: 'vahram',
      duration: 35,
      levels: [1, 2],
      lang: 'am',
      videoUrl: 'https://youtu.be/G9wyDenjTpg?si=HYF0Y3z-LrwMclzM'
    },
    {
      name: 'LLM Future is Multi-Model',
      speakerId: 'erik',
      duration: 35,
      levels: [],
      lang: 'am',
      videoUrl: 'https://youtu.be/ysYIMUsxIIA?si=V25btQysdghYAyU5'
    },
    {
      name: 'Introduction to MCP',
      speakerId: 'rouben',
      duration: 30,
      levels: [],
      lang: 'am',
      videoUrl: 'https://youtu.be/VR6r40j-pxg?si=1xfS7rnffgAZ_ZHO'
    },
    {
      name: "PANEL DISCUSSION: Programming, Vibe Coding. What's Next?",
      speakerId: ['edgar1', 'aram', 'vahram','vladimir'],
      duration: 45,
      levels: [],
      lang: 'am',
      videoUrl: 'https://youtu.be/tloz8ROc5n0?si=3cMAyDZv0WGR-P6D'
    },
    {
      name: 'Closing',
      duration: 30,
    },
  ],
  // BlackBox
  // [
  //   {
  //     name: '',
  //     duration: 30,
  //   },
  //   {
  //     name: 'JavaScript and Game Development',
  //     speakerId: 'arsen',
  //     duration: 35,
  //     levels: [],
  //     lang: 'am',
  //     videoUrl: 'https://bit.ly/3uijVhJ',
  //   },
  //   {
  //     name: 'Nuxt 3. What\'s new?',
  //     speakerId: 'vasiliy',
  //     duration: 35,
  //     levels: [1, 2],
  //     lang: 'ru',
  //     videoUrl: 'https://bit.ly/3tvTdDe',
  //   },
  //   {
  //     name: 'Audio and video manipulation',
  //     speakerId: 'david',
  //     duration: 35,
  //     levels: [],
  //     lang: 'am',
  //     videoUrl: 'https://bit.ly/36eH9xx',
  //   },
  //   {
  //     name: 'Control a drone with JavaScript',
  //     speakerId: 'suren',
  //     duration: 35,
  //     levels: [0, 1],
  //     lang: 'am',
  //     videoUrl: 'https://bit.ly/3N9Ut6T',
  //   },
  //   {
  //     name: 'Break',
  //     duration: 70,
  //   },
  //   {
  //     name: 'Why you should definitely use NgRx',
  //     speakerId: 'armenv',
  //     duration: 35,
  //     levels: [1, 2],
  //     lang: 'en',
  //     videoUrl: 'https://bit.ly/3ty16b6',
  //   },
  //   {
  //     name: 'The World Beyond console.log',
  //     speakerId: 'davit',
  //     duration: 35,
  //     levels: [],
  //     lang: 'am',
  //     videoUrl: 'https://bit.ly/3uheUGl',
  //   },
  //   {
  //     name: 'Local State and Server Cache: Finding a Balance',
  //     speakerId: 'natalia',
  //     duration: 30,
  //     levels: [1],
  //     lang: 'en',
  //     videoUrl: 'https://bit.ly/3qqjqkw',
  //   },
  //   {
  //     name: 'Break',
  //     duration: 20,
  //   },
  //   {
  //     name: 'Event Store - Cool replacement for React Context',
  //     speakerId: 'elmira',
  //     duration: 35,
  //     levels: [1, 2],
  //     lang: 'am',
  //     videoUrl: 'https://bit.ly/3ty16b6',
  //   },
  //   {
  //     name: 'Micro-frontend has entered the game',
  //     speakerId: 'vitaly',
  //     duration: 35,
  //     levels: [1],
  //     lang: 'ru',
  //     videoUrl: 'https://bit.ly/3JA4Gay',
  //   },
  // ],
];
